import { render } from "./bilibili-bot.vue?vue&type=template&id=ea62c260&ts=true"
import script from "./bilibili-bot.vue?vue&type=script&lang=ts"
export * from "./bilibili-bot.vue?vue&type=script&lang=ts"

import "./bilibili-bot.vue?vue&type=style&index=0&id=ea62c260&lang=scss"

import exportComponent from "/srv/bimgx-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__